import React from 'react';

import { Button, ArrowBackIcon } from 'src/components';

import styles from './BackButton.module.scss';

export const BackButton = ({ action, handleClick, basePath }) => {
	const back = (handleClick) => {
		handleClick();
	};
	return (
		<>
			<Button
				style={{ padding: '1px 0 2px 0' }}
				className={styles.backButton}
				onClick={() => back(handleClick)}
			>
				<ArrowBackIcon className={styles.arrowBackIcon} />
				{basePath && <span className={styles.materialGroup}>{basePath}</span>}
				{basePath && <span className={styles.slash}>/</span>}
				<span className={styles.action} data-testid={action}>
					{action}
				</span>
			</Button>
		</>
	);
};
